import * as api from '../api';
import { Model } from '../common';

@Model('UserProfile')
export class UserProfile extends api.ApiUserProfile {
    get localBirthday() {
        if (!this.birthday)
            return null;
        
        let birthdate = new Date(this.birthday);
        return new Date(birthdate.getTime() + birthdate.getTimezoneOffset() * 60 * 1000);
    }
}